// Helper function to get status color
export const getStatusColor = (status) => {
    switch (String(status || '').toLowerCase()) {
      case 'pending':
        return { backgroundColor: '#FEF3C7', color: '#CA8A04' };
      case 'booked':
        return { backgroundColor: '#D1FAE5', color: '#065F46' };
      case 'rejected':
        return { backgroundColor: '#FEE2E2', color: '#DC2626' };
      case 'in progress':
        return { backgroundColor: '#F3E8FF', color: '#9333EA' };
      case 'resolved':
        return { backgroundColor: '#DCFCE7', color: '#16A34A' };
      default:
        return { backgroundColor: '#f3f4f6', color: '#6b7280' };
    }
  };

    // Mock student data
 export const complaintData = [
      {
        id: 'CMP1234',
        studentName: 'Ayush Kumar',
        studentId: 'ST001',
        complaintCategory: 'Electrical',
        hostelType: 'UG',
        roomNo: '512',
        hostelBuilding: 'Building A',
        floor: '5th',
        complaintDate: '07 Aug 2025',
        status: 'In Progress',
        email: 'ayushkumar@gmail.com',
        mobile: '7656456787'
      },
      {
        id: 'CMP1236',
        studentName: 'Chirag Arrora',
        studentId: 'ST002',
        complaintCategory: 'Plumbing',
        hostelType: 'UG',
        roomNo: '502',
        hostelBuilding: 'Building A',
        floor: '5th',
        complaintDate: '05 Aug 2025',
        status: 'Resolved',
        email: 'ayushkumar@gmail.com',
        mobile: '7656456787'
      },
      {
        id: 'CMP1237',
        studentName: 'Ravi Sharma',
        studentId: 'ST003',
        complaintCategory: 'Wi-Fi/Internet',
        hostelType: 'UG',
        roomNo: '119',
        hostelBuilding: 'Building B',
        floor: '1st',
        complaintDate: '25 Nov 2025',
        status: 'Resolved',
        email: 'ayushkumar@gmail.com',
        mobile: '7656456787'
      },
      {
        id: 'CMP1238',
        studentName: 'Abhishek Singh',
        studentId: 'ST004',
        complaintCategory: 'AC',
        hostelType: 'UG',
        roomNo: '119',
        hostelBuilding: 'Building B',
        floor: '1st',
        complaintDate: '20 Apr 2026',
        status: 'Resolved',
        email: 'ayushkumar@gmail.com',
        mobile: '7656456787'
      },
      {
        id: 'CMP1238',
        studentName: 'Prachi Mehta',
        studentId: 'ST005',
        complaintCategory: 'Noise Complaint',
        hostelType: 'UG',
        roomNo: '119',
        hostelBuilding: 'Building B',
        floor: '1st',
        complaintDate: '20 Apr 2026',
        status: 'Pending',
        email: 'ayushkumar@gmail.com',
        mobile: '7656456787'
      },
      {
        id: 'CMP1239',
        studentName: 'Neha Gupta',
        studentId: 'ST006',
        complaintCategory: 'Key/Lock Issue',
        hostelType: 'UG',
        roomNo: '119',
        hostelBuilding: 'Building B',
        floor: '1st',
        complaintDate: '20 Apr 2026',
        status: 'Resolved',
        email: 'ayushkumar@gmail.com',
        mobile: '7656456787'
      },
      {
        id: 'CMP5101',
        studentName: 'Amit Singh',
        studentId: 'ST007',
        complaintCategory: 'Access Card',
        hostelType: 'PG',
        roomNo: '119',
        hostelBuilding: 'Building B',
        floor: '1st',
        complaintDate: '20 Apr 2026',
        status: 'In Progress',
        email: 'ayushkumar@gmail.com',
        mobile: '7656456787'
      },
      {
        id: 'CMP5104',
        studentName: 'Sneha Reddy',
        studentId: 'ST008',
        complaintCategory: 'Pest Control',
        hostelType: 'PG',
        roomNo: '119',
        hostelBuilding: 'Building B',
        floor: '1st',
        complaintDate: '20 Apr 2026',
        status: 'Pending',
        email: 'ayushkumar@gmail.com',
        mobile: '7656456787'
      },
      {
        id: 'CMP5108',
        studentName: 'Vikram Verma',
        studentId: 'ST009',
        complaintCategory: 'Water Leak',
        hostelType: 'UG',
        roomNo: '119',
        hostelBuilding: 'Building B',
        floor: '1st',
        complaintDate: '20 Apr 2026',
        status: 'Resolved',
        email: 'ayushkumar@gmail.com',
        mobile: '7656456787'
      },
      {
        id: 'CMP5111',
        studentName: 'Rahul Kumar',
        studentId: 'ST010',
        complaintCategory: 'Power Outlet Failure',
        hostelType: 'UG',
        roomNo: '119',
        hostelBuilding: 'Building B',
        floor: '1st',
        complaintDate: '20 Apr 2026',
        status: 'Resolved',
        email: 'ayushkumar@gmail.com',
        mobile: '7656456787'
      }
    ];
